export default new (class webconfig {
  // WebApi="http://napi.zhuniangjia.com";
  // WebApi="http://api.xc1919.com";
  // WebApi="https://localhost:44380";
  // WebApi="http://tapi.520985211.com";
  // WebApi="http://adx.xtea666.com";
  //WebApi = 'http://localhost:48154';
  WebApi='https://apis.dtmyg.com';
  // WebApi = "https://apiplus.xtea666.com";
  // WebApi = "https://api.xtea666.com";
  // WebApi="https://api.xiaozhuan.shop";
  // WebApi="http://natest.zhuniangjia.com";
  // WebApi="http://ttest.zhuniangjia.com";
  // SocketApi="http://localhost:8022";
  WeixinAppId = 'wx9f771109f6eb78be';
})()



// WEBPACK FOOTER //
// ./src/webconfig.config.js